module.exports = "/call-frontend/img/icon_search_active_outline.cd265600.svg";